import styled from 'styled-components/macro';

const BoldText = styled.h4`
	font-size: 1rem;
	font-weight: 800;
	color: var(--black-color);
	text-align: left;
	text-transform: capitalize;

	@media screen and (min-width: 2000px) {
		font-size: 1.1rem;
	}

	@media screen and (max-width: 450px) {
		font-size: 0.9rem;
	}
`;

export default BoldText;
